import httpRequest from '@/utils/request';

const projectUrl = '/Project';
const urlByProjectId = (projectId: string) => {
  return `/Project/${projectId}`;
};
const updateTeamsUrl = (projectId: string) => {
  return `/Project/${projectId}/teamIds`;
};
const updatUsersUrl = (projectId: string) => {
  return `/Project/${projectId}/users`;
};

export const getProjects = (params: IProject.IRequest.IGetProject = {}): Promise<IProject.IResponse.IData> => {
  return httpRequest.get(projectUrl, {
    params,
  });
};
export const updateProject = (params: IProject.IRequest.IUpdateProject): Promise<IResponseData.IBaseData> => {
  const url = urlByProjectId(params.projectId);
  return httpRequest.post(url, params.data);
};
export const deleteProject = (projectId: string): Promise<IResponseData.IBaseData> => {
  const url = urlByProjectId(projectId);
  return httpRequest.delete(url);
};
export const addTeams = (params: IProject.IRequest.IUpdateTeams): Promise<IResponseData.IBaseData> => {
  const url = updateTeamsUrl(params.projectId);
  return httpRequest.post(url, params.teamIds);
};
export const deleteTeams = (params: IProject.IRequest.IUpdateTeams): Promise<IResponseData.IBaseData> => {
  const url = updateTeamsUrl(params.projectId);
  return httpRequest.delete(url, {
    data: params.teamIds,
  });
};
export const addUsers = (params: IProject.IRequest.IUpdateUsers): Promise<IResponseData.IBaseData> => {
  const url = updatUsersUrl(params.projectId);
  return httpRequest.post(url, params.userIds);
};
export const deleteUsers = (params: IProject.IRequest.IUpdateUsers): Promise<IResponseData.IBaseData> => {
  const url = updatUsersUrl(params.projectId);
  return httpRequest.delete(url, {
    data: params.userIds,
  });
};
